import { api } from '@/api/client'
import type {
  HeaderWeather,
  WeatherCurrent,
  WeatherForecastDay,
  WeatherReadingsResponse,
  WeatherStation,
} from './types'

export async function fetchHeaderWeather(station = '27199'): Promise<HeaderWeather> {
  return api<HeaderWeather>(`/api/weather/kirov?station=${encodeURIComponent(station)}`)
}

export async function fetchCurrentWeather(station: string): Promise<WeatherCurrent> {
  return api<WeatherCurrent>(`/api/weather/current?station=${encodeURIComponent(station)}`)
}

export async function fetchWeatherForecast(): Promise<WeatherForecastDay[]> {
  const data = await api<WeatherForecastDay[]>('/api/weather/forecast')
  return Array.isArray(data) ? data : []
}

export async function fetchWeatherStations(): Promise<WeatherStation[]> {
  const data = await api<WeatherStation[]>('/api/weather/stations')
  return Array.isArray(data)
    ? data.map((s) => ({ id: String(s.id), name: s.name }))
    : []
}

export async function fetchWeatherReadings(
  station: string,
  days: number,
): Promise<WeatherReadingsResponse> {
  return api<WeatherReadingsResponse>(
    `/api/weather/readings?station=${encodeURIComponent(station)}&days=${days}`,
  )
}
